import { organizerSidebar } from '@/config/sidebarConfig';

import AdminRefundRequests from '../admin/AdminRefundRequests';

export default function OrganizerRefundRequests() {
  return <AdminRefundRequests sidebar={organizerSidebar} />;
}
